import { render, staticRenderFns } from "./detail_card_form.vue?vue&type=template&id=6959e300&scoped=true"
import script from "./detail_card_form.vue?vue&type=script&lang=js"
export * from "./detail_card_form.vue?vue&type=script&lang=js"
import style0 from "./detail_card_form.vue?vue&type=style&index=0&id=6959e300&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959e300",
  null
  
)

export default component.exports